import styled from "@emotion/styled";
import {Button} from "@mui/material";

export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;          
  padding: 40px;                  
  width: 100%;                    
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 10px;   /* Adjust padding on smaller screens */
  }
`;

export const UserTopElementsBlock = styled.div`
  display: flex;
  justify-content: space-between;   // Places search input on the left and button on the right
  align-items: center;              // Vertically center the input and button
  width: 100%;                      // Full width of the block
  padding: 10px 0;                  // Optional: Adjust padding for spacing

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;         // Stack vertically on mobile
    align-items: stretch;
  }
`;

export const   UserSerchInputWrapper = styled.div`
  flex-grow: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;  // Full width on mobile
    padding: 10px;  // Add padding for better spacing
  }
`;

export const UserButtonWrapper = styled.div`
  flex-shrink: 0;
  padding-left: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding-left: 0;
    align-self: flex-end;   // Align button to the right on mobile
  }
`;

export const UserListWrapper = styled.div`
  flex-grow: 1;
  display: flex;    
  justify-content: center;   

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;    // Ensure the table fills the width of mobile screens
  }
`;

export const UsersTitle = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.h2}; /* Use large font size from the theme */
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.primary}; /* Use primary text color from the theme */
  margin-bottom: ${({ theme }) => theme.spacing('medium')}; /* Space between title and counters */
  margin-left: 5px;
`;

export const AddUserButton = styled(Button)`
  padding: 12px 40px;               
  font-size: 16px;                   
  color: #fff;                       
  border-color: #fff;                
  transition: all 0.3s ease; 
  &:hover {
    background-color: rgba(93, 98, 182, 0.1); /* Change hover background color */
    border-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.main};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    /* Adjust the button on smaller screens */
    font-size: 14px;
    padding: 12px 120px;
    margin-block: 10px;
    margin-right: 12px;
  }
`;

export const UserButtonIcon = styled.svg`
width: 20px;
height: 20px;
`;

export const UserIconWraper = styled.div`
  display: flex;
  justify-content: center;
`;

export const UsersCardsWrap = styled.div`
    width: 100%;
    box-sizing: border-box;
    margin-top: 16px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;

    @media (max-width: 1008px) {
        grid-template-columns: 1fr;
        padding: 0 16px;
    }
`;

export const UserCard = styled.div`
    background: #2c2f3f;
    border-radius: 12px;
    padding: 14px;
    width: 100%;
    box-sizing: border-box;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease, opacity 0.2s ease;
    opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};

    &:hover {
        background: #34374a;
    }
`;

export const UserDisabledChip = styled.span`
    display: inline-block;
    margin-left: 8px;
    padding: 2px 8px;
    border-radius: 999px;
    background: rgba(242, 65, 85, 0.15);
    color: #f24155;
    font-size: ${({ theme }) => theme.fontSizes.small};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    text-transform: uppercase;
    letter-spacing: 0.4px;
    vertical-align: middle;
`;

export const UserCardRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;
`;

export const UserCardMain = styled.div`
    min-width: 0;
    flex: 1 1 auto;
`;

export const UserCardTitle = styled.div`
    font-size: ${({ theme }) => theme.fontSizes.large};
    color: ${({ theme }) => theme.colors.text.primary};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const UserCardSub = styled.div`
    margin-top: 4px;
    font-size: ${({ theme }) => theme.fontSizes.medium};
    color: ${({ theme }) => theme.colors.text.secondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const UserCardActions = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
`;

export const UserCardMeta = styled.div`
    margin-top: 10px;
    font-size: ${({ theme }) => theme.fontSizes.medium};
    color: ${({ theme }) => theme.colors.text.secondary};
    opacity: 0.9;
`;
